<template>
    <v-row>
        <div class="col-md-12 home-box">
            <Breadcrumbs :title="'Other Incomes Types'"></Breadcrumbs>
            <OtherIncomeList></OtherIncomeList>
        </div>
    </v-row>
</template>

<script>
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import OtherIncomeList from "../../components/Income/OtherIncomeList.vue";
export default {
    name: 'batchList',
    components:{
        Breadcrumbs,
        OtherIncomeList
    }
}
</script>